import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  static targets = ["modalForm", "menuForm", "modal"];

  connect() {
    this.initializeToast();
  }

  populateModal(event) {
    const [_data, _status, xhr] = event.detail;
    this.modalFormTarget.innerHTML = xhr.response;

    var modal = bootstrap.Modal.getOrCreateInstance(this.modalTarget);
    modal.show();

    this.removeClickedClass();
    event.target.classList.add("clicked");
  }

  updateMenuForm(event) {
    const [_data, _status, xhr] = event.detail;
    this.menuFormTarget.innerHTML = xhr.response;
  }

  closeModal() {
    const modal = bootstrap.Modal.getInstance(this.modalTarget);
    modal.hide();
  }

  removeClickedClass() {
    const boxes = document.querySelectorAll(".nav-link-light.clicked");
    boxes.forEach((box) => {
      box.classList.remove("clicked");
    });
  }

  initializeToast() {
    const toastElList = document.querySelectorAll(".toast");
    toastElList.forEach((toastEl) => {
      const toast = new bootstrap.Toast(toastEl);
      toast.show();
    });
  }
}
